import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../../store';

/**
 * Redirects /inbox to /inbox/:personId using the current logged-in agent's id.
 * Preserves query params (e.g. ?unread=true).
 */
const InboxRedirect = () => {
  const { loggedInAgent } = useAuthStore();
  const { search } = useLocation();
  const personId = loggedInAgent?.id ?? '';
  return <Navigate to={`/inbox/${personId}${search}`} replace />;
};

export default InboxRedirect;
